export default "__VITE_ASSET__JTuMI5u1__"